import VerticalSlider from '@/components/dataDisplay/VerticalSlider';
import {
  AMPLITUDE_ACTIONS,
  AMPLITUDE_TUITION_FEES_DIRECTIONS,
} from '@/modules/core/amplitude/events';
import { LogEvent } from '@/modules/core/amplitude/types/Amplitude';
import { EducationalProgramStep } from '@/modules/core/data/types/EducationalProgramStep';
import { GenericObject } from '@/modules/core/data/types/GenericObject';
import { SetActiveEducationalProgramStep } from '@/modules/core/data/types/SetActiveEducationalProgramStep';
import { SetTransition } from '@/modules/core/data/types/SetTransition';
import { Amplitude } from '@amplitude/react-amplitude';
import { css } from '@emotion/react';
import size from 'lodash.size';
import React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';

type Props = {
  selectedEducationalProgramSteps: EducationalProgramStep[];
  setActiveEducationalProgramStep: SetActiveEducationalProgramStep;
  setTransition: SetTransition;
  previousStep: EducationalProgramStep;
  nextStep: EducationalProgramStep;
}

/**
 * Navigation bar between steps.
 *
 * @param {Props} props
 * @return {JSX.Element}
 * @constructor
 */
const EducationalProgramStepsFeesNavBar: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    selectedEducationalProgramSteps,
    setActiveEducationalProgramStep,
    setTransition,
    previousStep,
    nextStep,
  }: Props = props;
  const hasManySteps = size(selectedEducationalProgramSteps) > 1;

  if (selectedEducationalProgramSteps && hasManySteps) {
    return (
      <Amplitude
        eventProperties={(inheritedProps): GenericObject => ({
          ...inheritedProps,
        })}
      >
        {({ logEvent }: { logEvent: LogEvent }): JSX.Element => (
          <Row
            css={css`
              @media (max-width: 991.98px) {
                display: inline-block;
              }
            `}
          >
            <Col
              md={6}
              xs={12}
            >
              {
                hasManySteps && (
                  <VerticalSlider
                    handleUpClick={() => {
                      setActiveEducationalProgramStep(previousStep);
                      setTransition('up');
                      setTimeout(() => {
                        setTransition(null);
                      }, 300); // Must be the same timeout as the animation duration itself

                      logEvent('solutions-tuitionFees-displayed', {
                        selection: {
                          ref: previousStep.ref,
                          isDefault: false,
                          direction: AMPLITUDE_TUITION_FEES_DIRECTIONS.PREVIOUS,
                        },
                        action: AMPLITUDE_ACTIONS.CLICK,
                      });
                    }}
                    handleDownClick={() => {
                      setActiveEducationalProgramStep(nextStep);
                      setTransition('down');
                      setTimeout(() => {
                        setTransition(null);
                      }, 300); // Must be the same timeout as the animation duration itself

                      logEvent('solutions-tuitionFees-displayed', {
                        selection: {
                          ref: nextStep.ref,
                          isDefault: false,
                          direction: AMPLITUDE_TUITION_FEES_DIRECTIONS.NEXT,
                        },
                        action: AMPLITUDE_ACTIONS.CLICK,
                      });
                    }}
                  />
                )
              }
            </Col>
          </Row>
        )}
      </Amplitude>
    );
  } else {
    return (
      // Displaying an empty div will force to use the flex mode which will automatically center the content
      <div />
    );
  }
};

export default EducationalProgramStepsFeesNavBar;
